import script from "./ServiceStatusItemPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceStatusItemPage.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceStatusItemPage.vue?vue&type=style&index=0&id=6d5b053f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d5b053f"]])

export default __exports__